import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  StyleSheet,
  TouchableOpacity,
  View,
  FlatList,
  ActivityIndicator,
} from "react-native";

// Custom Imports
import color from "@constants/color";
import { scale } from "@utils/scale";
import t from "@constants/localization";
import BackArrow from "@assets/svg/BackArrow";
import CustomText from "@components/CustomText";
import contestAction from "@actions/contest.action";
import CircularLoader from "@screens/Story/CircularLoader";
// import OrderDetailsModal from "@screens/ClTasks/OrderDetailsModal";
import {
  contestCxOrderedSelector,
  moreOrderedCustLoadingSelector,
} from "@selectors/contest.selector";
import { OrderedEmptyComponent } from "../Components/ContestEmptyComponent";
import AlreadyOrderedCustomers from "../Components/AlreadyOrderedCustomers";
import contestEvents from "../ContestEvents";

const PATH = "screens/Contest";

function OrderedList({ navigation, route }) {
  const { contest_id = 0, orderedCx = 0 } = route?.params || {};
  const [orderItem, setOrderItem] = useState({});
  const [orderModal, setOrderModal] = useState(false);

  const dispatch = useDispatch();
  const { data = [], api = {} } = useSelector(contestCxOrderedSelector);
  const { pending = false } = api || {};
  const moreOrderedCustLoading = useSelector(moreOrderedCustLoadingSelector);
  const { contestLeaderCustomers = [] } = data || {};

  useEffect(() => {
    dispatch(
      contestAction.getContestCxOrderedContest.pending(
        { contest_id, limit: 10, offset: 0 },
        null,
      ),
    );
  }, []);

  const onBackClick = () => {
    navigation.goBack();
  };

  const handleOrderDetailsModal = (flag) => {
    setOrderModal(flag);
    setOrderItem({});
  };

  const onPressOrder = (item) => {
    setOrderItem(item);
    setOrderModal(true);
  };

  const loadMore = useCallback(async () => {
    if (contestLeaderCustomers.length === 0) {
      return;
    }
    if (contestLeaderCustomers.length === orderedCx) {
      return;
    }
    try {
      if (orderedCx > contestLeaderCustomers.length) {
        dispatch(contestAction.updateMoreOrderedCustLoading(true));
        dispatch(
          contestAction.getContestCxOrderedContest.pending(
            { contest_id, limit: 10, offset: contestLeaderCustomers.length },
            null,
          ),
        );
      }
    } catch (e) {
      console.log(e);
      dispatch(contestAction.updateMoreOrderedCustLoading(false));
    }
  }, [contestLeaderCustomers, orderedCx]);

  const customerDataFooter = () => {
    return (
      <>
        {moreOrderedCustLoading ? (
          <ActivityIndicator size="large" color={color.primary} />
        ) : null}
      </>
    );
  };

  const _keyExtractor = (item, index) => `${index}`;

  const _renderItem = ({ item, index }) => {
    if (item) {
      return (
        <AlreadyOrderedCustomers
          item={item}
          onPressOrder={onPressOrder}
          contestEvents={contestEvents}
          navigation={navigation}
        />
      );
    } else return null;
  };

  return (
    <View style={styles.container}>
      <View style={styles.headerTitleContainer}>
        <TouchableOpacity activeOpacity={0.8} onPress={onBackClick}>
          <BackArrow />
        </TouchableOpacity>
        <CustomText
          variant="title_20"
          newfont={true}
          numberOfLines={1}
          style={styles.textLeftPadding}
        >
          {t(`${PATH}/ordered`)}
        </CustomText>
      </View>
      {!moreOrderedCustLoading && pending ? (
        <View style={styles.loaderStyle}>
          <CircularLoader />
        </View>
      ) : (
        <FlatList
          renderAheadOffset={10}
          data={contestLeaderCustomers}
          renderItem={_renderItem}
          keyExtractor={_keyExtractor}
          showsVerticalScrollIndicator={false}
          style={styles.listContainer}
          contentContainerStyle={styles.contentContainer}
          onEndReached={loadMore}
          ListEmptyComponent={OrderedEmptyComponent}
          ListFooterComponent={customerDataFooter}
        />
      )}
    </View>
  );
}

export default OrderedList;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: color.white,
  },
  headerTitleContainer: {
    alignItems: "center",
    flexDirection: "row",
    height: 56,
    paddingHorizontal: 16,
    backgroundColor: color.white,
    elevation: 8,
    shadowColor: color.mediumBlack,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4.65,
  },
  textLeftPadding: {
    paddingLeft: scale(23),
    color: color.mediumBlack,
  },
  listContainer: {
    marginTop: 1,
    flex: 1,
  },
  contentContainer: {
    flexGrow: 1,
    paddingBottom: 20,
    backgroundColor: color.white,
    paddingHorizontal: 16,
  },
  loaderStyle: {
    position: "absolute",
    alignSelf: "center",
    zIndex: 100,
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
});
